import { 
  createAsyncAction,
  createStandardAction,
} from "typesafe-actions";
import {
  IListResponse,
  ITrack,
  IUpdate,
} from "../api";

interface IListMeta {
  page: number,
}

export const fetchTrack = createAsyncAction(
  'FETCH_TRACK_REQUEST',
  'FETCH_TRACK_SUCCESS',
  'FETCH_TRACK_ERROR',
)<void, ITrack, Error>();

export const updateTrackProgress = createAsyncAction(
  'UPDATE_TRACK_REQUEST',
  'UPDATE_TRACK_SUCCESS',
  'UPDATE_TRACK_ERROR',
)<IUpdate, ITrack, Error>();

export const fetchTracksRequest = createStandardAction('FETCH_TRACKS_REQUEST')<void, IListMeta>();
export const fetchTracksSuccess = createStandardAction('FETCH_TRACKS_SUCCESS')<IListResponse, IListMeta>();
export const fetchTracksFailure = createStandardAction('FETCH_TRACKS_FAILURE')<Error, IListMeta>();



// WEBPACK FOOTER //
// ./src/actions/trackActions.ts